import type { EventData, EventDescriptor } from './input.service';

export class InputEventInfo {
	constructor(
		public descriptor: EventDescriptor,
		public callback: (data: EventData) => void
	) {}

	shouldTrigger(eventDescriptor: EventDescriptor): boolean {
		// check event type: i.e. "keydown", "keyup"
		if (this.descriptor.eventType !== eventDescriptor.eventType) {
			return false;
		}

		// Check if modifiers are matching
		const modifiersMatch =
			this.descriptor.modifiers.ctrl === eventDescriptor.modifiers.ctrl &&
			this.descriptor.modifiers.shift === eventDescriptor.modifiers.shift &&
			this.descriptor.modifiers.alt === eventDescriptor.modifiers.alt &&
			this.descriptor.modifiers.meta === eventDescriptor.modifiers.meta;

		if (!modifiersMatch) {
			return false;
		}

		// If the code is undefined, it means any key is acceptable
		if (this.descriptor.code === undefined) {
			return true;
		}

		// otherwise compare the keyboard event code
		return this.descriptor.code === eventDescriptor.code;
	}
}
